/**
 * Fetch the preferred language for the app.
 * Default language is defined in the .env variable or is set to English.
 */
const getPreferredLanguage = (language, messages) => {

    /**
     * Language set by the browser.
     * If the i18n supports the the navigator language it will update it as its preferred language.
     */
    function browserLanguage(messages) {
        let browser = null;

        if (navigator.languages && navigator.languages.length) {
            // Latest versions of Chrome and Firefox set this correctly
            browser = navigator.languages[0];
        } else if (navigator.userLanguage) {
            // IE only
            browser = navigator.userLanguage;
        } else {
            // Latest versions of Chrome, Firefox, and Safari set this correctly
            browser = navigator.language;
        }

        return messages.hasOwnProperty(browser) ? browser : null;
    }

    /**
     * Language set by the system.
     */
    function systemLanguage(language) {
        return language ? language : process.env.REACT_APP_LANGUAGE;
    }

    let result = browserLanguage(messages);

    if (!result) {
        return systemLanguage(language.system);
    }

    return result;
};

export default getPreferredLanguage;



// WEBPACK FOOTER //
// ./src/helpers/preferredLanguage.js